/**
 * Sandbox "Test Drive" guided tour — step script.
 * Each step highlights a nav item; the visitor clicks it to navigate, then
 * sees an explanation of that feature before moving to the next highlight.
 */
export const tourSteps = [
  {
    id: 'welcome',
    kind: 'intro',
    title: 'Welcome to ISOCNTRL',
    body: "You're exploring a live sandbox with realistic (fictitious) leads, merchants and residuals. Nothing here touches real data. Let's walk through the platform — click Next to begin.",
  },
  {
    id: 'leads',
    navTestId: 'nav-leads',
    route: '/leads',
    title: 'Boarding a Lead',
    body: 'This is your CRM. Every prospect becomes a tracked lead here — open one to schedule a follow-up call, generate pricing, or send an informational email in a couple of clicks.',
  },
  {
    id: 'pipeline',
    navTestId: 'nav-merchant-services',
    route: '/pipeline/merchant_services',
    title: 'Your Sales Pipeline',
    body: 'This Kanban board shows every deal moving from New Lead through Live. Drag a card to advance its stage — your team always knows what needs attention next.',
  },
  {
    id: 'equipment',
    navTestId: 'nav-equipment',
    route: '/equipment',
    title: 'Ordering Equipment',
    body: 'Once a merchant account is boarded and submitted, order their terminals and POS hardware right here — quantities, placement, and billing method all in one place.',
  },
  {
    id: 'residuals',
    navTestId: 'nav-my-residuals',
    route: '/residuals',
    title: 'Residuals — Your Earnings',
    body: "This is where your monthly residual income lives, broken out by processing platform (we've renamed them MSC-TSYS, MSC-Fiserv and MSC-Epx for clarity). When you're ready to get paid, use the Payout button on any row.",
  },
  {
    id: 'form-builder',
    navTestId: 'nav-form-builder',
    route: '/leads/form-builder',
    title: 'Lead Capture Forms',
    body: 'Build a shareable web form in minutes — embed it on your website or share the link, and every submission drops straight into your pipeline as a new lead.',
  },
  {
    id: 'statement-analysis',
    navTestId: 'nav-statement-analysis',
    route: '/statement-analysis',
    title: 'Statement Analysis & Proposals',
    body: "Uploading and analyzing statements is turned off in this sandbox, but check out the Statements tab to download a sample analysis, and the Proposals tab to see exactly what your merchant sees when you send them an offer.",
  },
  {
    id: 'calendar',
    navTestId: 'nav-calendar',
    route: '/calendar',
    title: 'Calendar',
    body: 'Connect your own Google account and every meeting you book here syncs both ways automatically — no more double-booking or missed appointments.',
  },
  {
    id: 'map',
    navTestId: 'nav-map-view',
    route: '/map',
    title: 'Nearby Leads on the Map',
    body: 'Find businesses to prospect near any address using Google Maps, right from inside the CRM — perfect for planning a canvassing route.',
  },
  {
    id: 'documents',
    navTestId: 'nav-documents',
    route: '/documents',
    title: 'Document Library',
    body: "This is your agency's own document library — store agreements, ID templates, and compliance files here so your whole team can find them.",
  },
  {
    id: 'payments',
    navTestId: 'nav-payments',
    route: '/payments',
    title: 'Payments — Virtual Terminal',
    body: 'Once your account with us is activated, this tab lets you run ACH transfers and credit card charges through a virtual terminal — no third-party gateway needed.',
  },
  {
    id: 'users',
    navTestId: 'nav-team-&-users',
    route: '/users',
    title: 'Team & Users',
    body: 'Manage your whole team from here — add agents and subagents, and control exactly what each person can see and do.',
  },
  {
    id: 'settings',
    navTestId: 'nav-my-settings',
    route: '/my-settings',
    title: 'Settings',
    body: "Settings covers your account security (like two-factor login), email connections, and the payment methods you'll use to purchase equipment or receive your residual payouts.",
  },
  {
    id: 'finish',
    kind: 'outro',
    title: "You've completed the tour!",
    body: "That's ISOCNTRL end to end — prospecting, pipeline, applications, residuals and more, all in one place. Ready to bring your own agency on board?",
  },
];
